// Kept apart from GoogleMapsProvider.tsx so importing it never pulls the provider into the entry chunk.
export const importGoogleMapsProvider = () => import('./GoogleMapsProvider');
